<template>
  <div class='pc-nav' :style="{height: nonChrome?'96px':'56px'}">
    <div v-if="nonChrome" class="nonChrome">
      为了保证制作简历的安全性和流畅性，建议您使用Chrome浏览器进行访问
      <i class="iconfont iconx close" @click="close"></i>
    </div>
    <div class='nav-container'>
      <img @click="toIndex" class="logo" alt="超级简历WonderCV LOGO" src="https://photo.wondercv.com/white-logo.png">
   <!-- :style="{'width':isLogin ? '438px' : '350px'}" -->
      <div v-if="navLoaded" class='middle'>
         <!-- @click='toCv(nav)' -->
        <div v-for="nav in navList" :key="nav.label" class='middle-item' :class="{'header-active': navbarAction === nav.label}" :href="nav.url" @click="setNavbarAction(nav)">
          <img class="label-image" v-if="nav.image" :src="nav.image" alt="">
          <span v-else>{{nav.label}}</span>
          <!-- <img v-if="nav.img" :src="nav.img"> -->
          <img v-show="(nav.url === '/service/') && banner.image" :src="banner.image">
        </div>
      </div>


      <div class="right-part">
        <div>
          <member-status-popup></member-status-popup>
          <appIcon/>
          <div class="line"></div>
          <!-- 未登录 -->
          <div v-if="!isLogin">
            <button @click='toLogin' class="margin-left">登录</button>
            <button class="action" @click='toReg'>注册</button>
          </div>
          <!-- 登陆 -->
          <div v-else>
            <personIcon/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import Cookies from 'js-cookie'

  window.Cookies = Cookies;
  import api from '@/api'
  import personIcon from './personIcon'
  import appIcon from './phone'
  import memberStatusPopup from './memberStatusPopup'
  import moment from 'moment';
  import {getSignature, getUserInfo, dealSignatrue, routerTo, updateJWT, getBannerParams} from '~/assets/js/util'

  export default {
    props: {
      currHeader: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        moment,
        navList: [
          // {label: '简历模板', url: '/jianlimoban/'},
          {label: '名企热招', url: '/jobs/', id: 142},
          {label: '简历修改', url: '/service/', id: 140},
          {label: '求职攻略', url: '/blog/', id: 143},
          // {label: '精选课程', url: '/course', id: 144},
          // {label: '经验讨论', url: '/community/'},
          // {label: '加入我们', url: '/welcome/join_us', img: 'https://files.wondercv.com/hot-icon.png'}
        ],
        useByPhone: 'app',
        usePhone: false,
        personalMenuStatus: false,
        banner: {},
        navImages: {},
        // navIds: [139, 140, 141, 142, 143, 144, 154],
        navIds: [139, 140, 141, 142, 143, 154],
        navLoaded: false
      }
    },
    computed: {
      ...mapState('me', ['isLogin', 'personInfo', 'isMembership', 'isUser']),
      ...mapState('app', ['navbarAction', 'isDouble']),
      ...mapState('global', ['nonChrome'])
    },
    components: {
      personIcon,
      appIcon,
      memberStatusPopup
    },
    watch: {
      isLogin: {
        handler(val) {
          this.changeNavListData(val)
          if (val) {
            this.getUserInfo()
          }
        },
        immediate: true
      },
      personInfo: {
        deep: true,
        immediate: true,
        handler(val) {
          if (val.is_student === true) {
            this.navList = this.navList.map(item => {
              if (item.label === '名企热招') {
                item.url = '/campus_recruiting/user_show'
              }
              return item
            })
            // 没有身份
          } else if (val.is_student === null) {
            // routerTo('/template_matches/new')
          } else if (this.isLogin) {
            this.navList = this.navList.map(item => {
              if (item.label === '名企热招') {
                item.url = '/jobs/recommend'
              }
              return item
            })
          }
        }
      }
    },
    async created () {

      await Promise.all(this.navIds.map(item => this.getNavImage(item)))
      this.changeNavListData(this.isLogin);
      this.navLoaded = true;

      try {
        let res = await api.jobs.getV4Banner(getBannerParams(40));
        if (res.code === 1000 && res.data.length) {
          this.banner = res.data[0]
        }
      } catch (error) {
        console.log(error)
      }

      // 学生身份修改 navbar 没有身份跳转至选择身份走 onboarding 流程
      if (this.personInfo.is_student === true) {
        this.navList = this.navList.map(item => {
          if (item.label === '热门职位') {
            item.url = '/campus_recruiting/user_show'
          }
          return item
        })
      } else if (this.personInfo.is_student === null) {
        // routerTo('/template_matches/new')
      }
    },
    methods: {
      ...mapMutations("global", ['setNonChrome']),
      ...mapActions("me", ["getUserInfo"]),
      toRoot() {
      },
      toCv(nav) {
        routerTo(nav.url)
      },
      toEmail() {
      },
      toJob() {
      },
      toService() {
      },
      toIndex() {
        routerTo('/')
      },
      toLogin() {
        routerTo('/auth-signin/?type=login')
      },
      toReg() {
        routerTo('/auth-signin/?type=login')
      },
      changeNavListData(isLogin) {
        if (isLogin) {
          const navList = [
            {label: '我的简历', url: '/cvs', id: 139},
            {label: '简历修改', url: '/service/', id: 140},
            {label: '校招信息', url: '/jobs/campus/info', id: 154},
            {label: '简历模板', url: '/jianlimoban/', id: 141},
            {label: '名企热招', url: '/jobs/', id: 142},
            {label: '求职攻略', url: '/blog/', id: 143},
            // {label: '精选课程', url: '/course', id: 144}
          ]
          this.navList = navList.map(item => ({
            ...item,
            image: this.navImages[item.id]
          }))
        } else {
          const navList = [
            {label: '简历修改', url: '/service/', id: 140},
            {label: '校招信息', url: '/jobs/campus/info', id: 154},
            {label: '简历模板', url: '/jianlimoban/', id: 141},
            {label: '名企热招', url: '/jobs/', id: 142},
            {label: '求职攻略', url: '/blog/', id: 143},
            // {label: '精选课程', url: '/course', id: 144}
          ]
          this.navList = navList.map(item => ({
            ...item,
            image: this.navImages[item.id]
          }))
        }
        this.$forceUpdate()
      },
      async getNavImage(id) {
        try {
          const { code, data } = await api.jobs.getV4Banner(getBannerParams(id));
          if (code === 1000 && data.length) {
            this.navImages[id] = data[0].image;
          }
        } catch (error) {
          console.log(error);
        }
      },
      changeUsePhone(type) {
        this.useByPhone = type
      },
      show(state) {
        this[state] = true
      },
      hide(state) {
        this[state] = false
      },
      // showAlert() {
      //   let alertData = {
      //     show: true,
      //     type: 'upVip'
      //   }
      //   this.$store.dispatch('app/setAlertData', alertData)
      // },
      close() {
        this.setNonChrome()
      },
      setNavbarAction(nav){
        if (!this.personInfo?.match) return this.$message.error('请先完成简历创建')
        // 菜单高亮
        this.$store.dispatch('app/setNavbarAction', nav.label);
        window.location.href = nav.url
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~/assets/css/variable';

  .close {
    color: #FF6644;
    position: absolute;
    top: 0px;
    right: 32px;
    font-size: 24px;
    cursor: pointer;
  }
  .nonChrome{
    width: 100%;
    height: 40px;
    background-color:#FFF6F4;
    color: #FF6644;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    position: relative;
  }
  .pc-nav {
    position: fixed;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 56px;
    z-index: 9;
    background-color: #202329;
    box-sizing: border-box;
    user-select:none;

    .nav-container {
      /*height: 100%;*/
      height: 56px;
      width: 1196px;
      margin: auto;
      position: relative;
      text-align: center;

      .logo {
        vertical-align: middle;
        height: 32px;
        position: absolute;
        left: 0;
        top: 12px;
        z-index: 3;
        cursor: pointer;
      }

      .middle {
        // width: 360px;
        margin: auto;
        display: inline-flex;

        .middle-item {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 38px;
          // flex: 1;
          text-align: center;
          color: #fff;
          height: 55px;
          line-height: 55px;
          cursor: pointer;
          position: relative;
          a {
            color: $color-title;
          }

          &:hover {
            // color: #ff4f4c;
            font-weight: 600;
          }

          &:last-child {
            margin: 0;
          }

          img {
            position: absolute;
            top: -2px;
            left: 47px;
            height: 29px;
          }
          .label-image {
            position: static;
          }
        }

        .header-active {
          font-weight: 600;
        }

        .header-active::after {
          content: "";
          display: block;
          width: 50%;
          height: 2px;
          background: #ff4f4c;
          position: absolute;
          left: 50%;
          bottom: -1px;
          transform: translateX(-50%);
        }
      }

      .right-part {
        flex: none;
        // min-width: 230px;
        height: 100%;
        z-index: 3;
        position: absolute;
        right: 0;
        top: 0;

        & > div {
          display: flex;
          align-items: center;
          height: 100%;
          justify-content: flex-end;
        }

        .line {
          width: 1px;
          height: 16px;
          background: #36393E;
          margin: 0 16px;
        }

        button {
          width: 76px;
          height: 30px;
          border: 1px solid #797B7E;
          color: #fff;
          cursor: pointer;
          margin-left: 16px;
          border-radius: 15px;
          font-size: 14px;
          background: #202329;

          &.action {
            background: #FF6644;
            border: 1px solid #FF6644;
          }

          &:hover {
            border: 1px solid #fff;
          }

          &.action:hover {
            background: #FF856A;
            border: 1px solid #FF856A;
          }

          &.margin-left {
            margin-left: 0;
          }
        }

        @media screen and (max-width: 1300px) {
          .vip p {
            // width: 140px;
          }
        }
      }
    }
  }
</style>
